import { render, staticRenderFns } from "./cardPopup.vue?vue&type=template&id=5a2f72af&scoped=true&"
import script from "./cardPopup.vue?vue&type=script&lang=js&"
export * from "./cardPopup.vue?vue&type=script&lang=js&"
import style0 from "./cardPopup.vue?vue&type=style&index=0&id=5a2f72af&prod&lang=scss&scoped=true&"
import style1 from "./cardPopup.vue?vue&type=style&index=1&id=5a2f72af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f72af",
  null
  
)

export default component.exports